.bandChartWrapper {
  & svg {
    height: 240px;
  }

  :global(path[data-testid='line-plot']) {
    color: var(--band-chart-line-color);
    stroke-width: 1px;
  }
}

.chartAndHorizonsWrapper {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
}
